<template>
  <div>
    <el-tooltip class="item" effect="light" :content="$t('post.sidebar.reportButton')" placement="top">
      <el-button type="primary" icon="el-icon-edit" circle @click="openCreateReportWindow"></el-button>
    </el-tooltip>

    <el-divider />

    <ul class="post-report-wrap">
      <li class="post-report-wrap__item" @click="openReportModal()">
        <el-tooltip :content="$t('post.sidebar.reportsTooltips[0]')" placement="top" effect="light">
          <el-link class="post-report-wrap__item-link" :underline="false" :href="csvLinkLight">
            <div class="in_link-wrap">
              <i class="fas fa-file fa-4x"></i>
              <span>{{$t('post.sidebar.reports[0]')}}</span>
            </div>
          </el-link>
        </el-tooltip>
      </li>
      <li class="post-report-wrap__item" @click="openReportModal()">
        <el-tooltip :content="$t('post.sidebar.reportsTooltips[1]')" placement="top" effect="light">
          <el-link class="post-report-wrap__item-link" :underline="false" :href="topSource">
            <div class="in_link-wrap">
              <i class="far fa-file-excel fa-4x"></i>
              <span>{{$t('post.sidebar.reports[1]')}}</span>
            </div>
          </el-link>
        </el-tooltip>
      </li>
      <li class="post-report-wrap__item" @click="openReportModal()">
        <el-tooltip :content="$t('post.sidebar.reportsTooltips[2]')" placement="top" effect="light">
          <el-link class="post-report-wrap__item-link" :underline="false" :href="fileDownloadLink">
            <div class="in_link-wrap">
              <i class="far fa-file-excel fa-4x"></i>
              <span>{{$t('post.sidebar.reports[2]')}}</span>
            </div>
          </el-link>
        </el-tooltip>
      </li>
      <li class="post-report-wrap__item" @click="openReportModal()">
        <el-tooltip :content="$t('post.sidebar.reportsTooltips[3]')" placement="top" effect="light">
          <el-link class="post-report-wrap__item-link" :underline="false" :href="fileDownloadLinkExcel">
              <div class="in_link-wrap">
                <i class="far fa-file-excel fa-4x"></i>
                <span>{{$t('post.sidebar.reports[3]')}}</span>
              </div>
          </el-link>
        </el-tooltip>
      </li>
      <li class="post-report-wrap__item">
        <el-tooltip :content="$t('post.sidebar.reportsTooltips[4]')" placement="top" effect="light">
          <el-link class="post-report-wrap__item-link" :underline="false" @click="openReportDialogSettings()">
            <div class="in_link-wrap" >
              <i class="far fa-file-word fa-4x"></i>
              <span>{{$t('post.sidebar.reports[4]')}}</span>
            </div>
          </el-link>
        </el-tooltip>
      </li>
      <li class="post-report-wrap__item" @click="openReportModal()">
        <el-tooltip :content="$t('post.sidebar.reportsTooltips[5]')" placement="top" effect="light">
          <el-link class="post-report-wrap__item-link" :underline="false" :href="dayLink">
              <div class="in_link-wrap">
                <i class="far fa-file-word fa-4x"></i>
                <span>{{$t('post.sidebar.reports[5]')}}</span>
              </div>
          </el-link>
        </el-tooltip>
      </li>
      <li class="post-report-wrap__item" @click="openReportModal()">
        <el-tooltip :content="$t('post.sidebar.reportsTooltips[6]')" placement="top" effect="light">
          <el-link class="post-report-wrap__item-link" :underline="false" :href="weekLink">
              <div class="in_link-wrap">
                <i class="far fa-file-word fa-4x"></i>
                <span>{{$t('post.sidebar.reports[6]')}}</span>
              </div>
          </el-link>
        </el-tooltip>
      </li>
    </ul>

    <el-dialog title="Сформировать отчет" :visible.sync="dialogReportVisible" width="380px">
        <el-form :model="reportForm">
          <el-form-item label="По">
            <el-select v-model="reportForm.typeReport" placeholder="Тип группировки">
              <el-option :label="type" :value="index" v-for="(type, index) in reportForm.items" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Формат">
            <el-radio-group v-model="reportFileType">
              <el-radio label="docx">Docx</el-radio>
              <el-radio label="pdf">Pdf</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer dialog-footer--report">
          <el-button @click="dialogReportVisible = false">Отмена</el-button>
          <el-button type="primary" @click="okModal()" style="margin-left: 15px">Загрузить</el-button>
        </span>
    </el-dialog>
    <el-dialog title="Формирование отчет" :visible.sync="modalReportVisible" width="380px">
      <p>Идёт формирование отчёта. Это может занять несколько минут. Вы можете продолжить работать в программе, нажав кнопку "ОК". Загрузка продолжится в фоновом режиме, отчёт сохранится в папку "Загрузки" на вашем компьютере.
      </p>

        <span slot="footer" class="dialog-footer dialog-footer--report">
          <el-button @click="modalReportVisible = false">ОK</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
  // vuex
  import { mapGetters } from 'vuex';

  // libraries
  import moment from "moment/moment";

  export default {
    name: 'Report',
    props: {
      csvLinkLight: {
        type: String
      },
      weekLink: {
        type: String
      },
      dayLink: {
        type: String
      },
      topSource: {
        type: String
      },
      fileDownloadLink: {
        type: String
      },
      fileDownloadLinkExcel: {
        type: String
      },
      dates: {
        type: Object
      }
    },
    data() {
      return {
        dialogReportVisible: false,
        modalReportVisible: false,
        reportForm: {
          typeReport: 'day',
          items: {
            day: "Дням",
            week: "Неделям",
            month: 'Месяцам',
            quart: "Кварталам",
          }
        },
        reportFileType: 'docx',
      };
    },
    methods: {
      openCreateReportWindow() {
        this.$emit('openCreateReportWindow');
      },
      openReportDialogSettings() {
        this.dialogReportVisible = true;
      },
      openReportModal() {
        this.modalReportVisible = true;
      },
      okModal() {
        this.dialogReportVisible = false;
        let date_from = moment(this.dates.date_from).format("YYYY-MM-DD");
        let date_to = moment(this.dates.date_to).format("YYYY-MM-DD");
        let basicLink = `https://${!window.location.href.includes('test111') ? 'api' : 'apitest'}.glassen-it.com/component/socparser/content/getReportDocx`;
        this.modalReportVisible = true;
        var link = document.createElement('a');
        link.setAttribute('href', `${basicLink}?thread_id=${this.$route.params.threadId}&date_from=${date_from}&date_to=${date_to}&type=${this.reportForm.typeReport}&format=${this.reportFileType}`); 
        link.setAttribute('download','pdfname');
        link.style.display = 'none';
        document.body.appendChild(link); 
        link.click(); 
        document.body.removeChild(link);
      },
    },
    computed: {
      ...mapGetters([
        'userLoginData',
      ])
    },
  };
</script>

<style>
  .post-report-wrap {
    padding: 20px 0 0 0;
    margin: 0;
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .post-report-wrap__item {
    margin-bottom: 20px;
  }
  .post-report-wrap__item-link {
    width: 210px;
    height: 150px;
    border: 1px solid #ccc;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .in_link-wrap {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-family: "Roboto", "Arial", sans-serif;
    font-style: normal;
    font-weight: 300;
    font-size: 12px;
  }
  .in_link-wrap span {
    text-align: center;
    margin-top: 10px;
  }
  .report-link {
    font-family: "Roboto", "Arial", sans-serif;
    color: #000;
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    text-decoration: none;
  }
  .el-dialog__body{
    word-break: break-word;
  }
  @media screen and (max-width: 480px) {
  .post-report-wrap__item-link{
    width: 172px;
  }
  }
</style>
